import React, { useState } from 'react';
import Slider from 'rc-slider';
/*
  Keep rc-slider on version 8.7.1 until further test.
  Fixes tooltip not moving with user action
  Reference: https://github.com/react-component/slider/issues/409
*/
import 'rc-slider/assets/index.css';
import './style.scss';

import { BdScrubberModel } from 'models/BdScrubberModel';
import { FlexGroup } from 'components/_common/FlexGroup';

type BdScrubberProps = {
  disabled?: boolean;
  min: number;
  max: number;
  minLabel?: string;
  maxLabel?: string;
  defaultValue: BdScrubberModel;
  onValueChange: (val: BdScrubberModel) => void;
  releaseTrigger?: (val: BdScrubberModel) => void;
  /** Formats the tooltip value display */
  tipFormatter?: (val: number) => string;
  minInterval?: number;
};

const labelStyle = {
  fontSize: '9px',
  lineHeight: '14px',
  letterSpacing: '0.4px',
  color: '#9A9CA3',
};

const toolTipProps = {
  placement: 'bottom',
  prefixCls: 'rc-slider-tooltip',
};

const { createSliderWithTooltip } = Slider;
const RangeControl = createSliderWithTooltip(Slider.Range);

export const BdScrubber: React.FC<BdScrubberProps> = ({
  disabled = false,
  min,
  max,
  minLabel = 'xxx xxxxx',
  maxLabel = 'xxx xxxxx',
  defaultValue,
  onValueChange,
  releaseTrigger = null,
  tipFormatter = val => `${val}`,
  minInterval = 1,
}) => {
  const dValue = disabled ? [min, max] : [defaultValue.startValue, defaultValue.endValue];
  const [cValue, setcValue] = useState<number[]>(dValue);

  return (
    <div>
      <RangeControl
        min={min}
        max={max}
        value={dValue}
        disabled={disabled}
        tipFormatter={tipFormatter}
        tipProps={toolTipProps}
        onChange={value => {
          if (value[1] > minInterval + value[0]) {
            setcValue(value);
          }
          onValueChange({ startValue: value[0], endValue: value[1] });
        }}
        onAfterChange={() => {
          const triggerValue = { startValue: cValue[0], endValue: cValue[1] };
          if (triggerValue.startValue !== dValue[0]) {
            triggerValue.startValue = cValue[1] - minInterval;
            triggerValue.endValue = cValue[1];
          } else if (triggerValue.endValue !== dValue[1]) {
            triggerValue.startValue = cValue[0];
            triggerValue.endValue = cValue[0] + minInterval;
          }
          onValueChange(triggerValue);
          releaseTrigger(triggerValue);
        }}
      />
      <FlexGroup
        suffix={
          <div
            style={{
              ...labelStyle,
              position: 'relative',
              right: '-2px',
            }}
          >
            {maxLabel}
          </div>
        }
        alignItems="end"
      >
        <div style={labelStyle}>{minLabel}</div>
      </FlexGroup>
    </div>
  );
};

export default BdScrubber;
